export const AbGoals = {
    MadeItToPin: 'AbGoalConfigs.Booking.MadeItToPin',
};
